import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react'
import React from 'react'

const ModalComponent = ({children, onClose, isOpen, size, title, closeBtn=true, closeModal, bg="#fff"}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={true} size={size ? size : "4xl"}  >
    <ModalOverlay />
    <ModalContent bg={bg}>
      <ModalHeader>{title}</ModalHeader>
      {closeBtn ? <ModalCloseButton onClick={closeModal} /> : ""}
      <ModalBody bg={bg}>
        {children}
      </ModalBody>

      {/* <ModalFooter>
        <Button colorScheme='blue' mr={3} onClick={onClose}>
          Close
        </Button>
        <Button variant='ghost'>Secondary Action</Button>
      </ModalFooter> */}
    </ModalContent>
  </Modal>

  )
}

export default ModalComponent